__turbopack_context__.v({
  "actions": "product-module__aEjafq__actions",
  "address": "product-module__aEjafq__address",
  "back": "product-module__aEjafq__back",
  "description": "product-module__aEjafq__description",
  "details": "product-module__aEjafq__details",
  "eyebrow": "product-module__aEjafq__eyebrow",
  "feedback": "product-module__aEjafq__feedback",
  "image": "product-module__aEjafq__image",
  "packageSummary": "product-module__aEjafq__packageSummary",
  "page": "product-module__aEjafq__page",
  "price": "product-module__aEjafq__price",
  "product": "product-module__aEjafq__product",
  "quantity": "product-module__aEjafq__quantity",
});
